<template>
  <div class="welcome-container">
    <div class="welcome-header">
      <h1>欢迎回来，{{ username }}！</h1>
      <p>祝您今天工作愉快</p>
    </div>

    <div class="welcome-content">
      <div class="stats-container">
        <div class="stat-card" v-for="stat in stats" :key="stat.title">
          <div class="stat-icon" :style="{ backgroundColor: stat.color }">
            {{ stat.icon }}
          </div>
          <div class="stat-info">
            <h3>{{ stat.value }}</h3>
            <p>{{ stat.title }}</p>
          </div>
        </div>
      </div>

      <div class="recent-activity">
        <h2>最近活动</h2>
        <el-table :data="recentData" style="width: 100%">
          <el-table-column prop="date" label="日期" width="180"></el-table-column>
          <el-table-column prop="action" label="操作" width="180"></el-table-column>
          <el-table-column prop="detail" label="详情"></el-table-column>
        </el-table>
      </div>
    </div>

    <div class="welcome-footer">
      <el-button type="primary" @click="logout">退出登录</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WelcomeHome',
  data() {
    return {

      stats: [
        { title: '总用户数', value: '1,234', icon: '👥', color: '#409EFF' },
        { title: '今日访问', value: '128', icon: '📊', color: '#67C23A' },
        { title: '待处理事项', value: '5', icon: '📝', color: '#E6A23C' },
        { title: '系统状态', value: '正常', icon: '✅', color: '#67C23A' }
      ],
      recentData: [
        { date: '2023-06-01 09:30', action: '登录系统', detail: '通过PC端登录' },
        { date: '2023-06-01 10:15', action: '查看数据', detail: '访问用户管理页面' },
        { date: '2023-06-01 14:20', action: '更新信息', detail: '修改用户资料' },
        { date: '2023-05-31 16:45', action: '系统操作', detail: '导出数据报表' }
      ]
    }
  }, computed: {
    username() {
      return this.$store.state.username;
    }
  },
  methods: {
    logout() {
      // 退出登录逻辑
      this.$message.success('已退出登录');
      // 可以添加路由跳转逻辑
      // this.$router.push('/login');
    }
  }
}
</script>

<style scoped>
.welcome-container {
  height: 70vh;
  background-color: #f5f7fa;
  padding: 20px;
  border-radius: 8px;
}

.welcome-header {
  text-align: center;
  margin-bottom: 30px;
}

.welcome-header h1 {
  color: #303133;
  font-size: 28px;
  margin-bottom: 10px;
}

.welcome-header p {
  color: #606266;
  font-size: 16px;
}

.stats-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 30px;
}

.stat-card {
  display: flex;
  align-items: center;
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  width: calc(50% - 10px);
  box-sizing: border-box;
}

.stat-icon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  margin-right: 15px;
}

.stat-info h3 {
  margin: 0 0 5px 0;
  color: #303133;
  font-size: 24px;
}

.stat-info p {
  margin: 0;
  color: #909399;
}

.recent-activity h2 {
  color: #303133;
  margin-bottom: 15px;
}

.welcome-footer {
  text-align: center;
  margin-top: 30px;
}

@media (max-width: 768px) {
  .stat-card {
    width: 100%;
  }
}
</style>
